(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen-banners/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen-banners/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.andra_chansen_banners = svs.numbergames.andra_chansen_banners || {};
svs.numbergames.ReactAndraChansenBanners = svs.numbergames.ReactAndraChansenBanners || {};
svs.numbergames.andra_chansen_banners.logger = new svs.core.log.Logger('numbergames:andra_chansen_banners');

 })(window);